export default "__VITE_ASSET__BlQeWN8n__"